// extracted by mini-css-extract-plugin
export default {"page-report":"LayoutReport_page-report__U4ss5"};